import { Expose } from 'class-transformer';
import { DvSnapshot } from './snapshot.entity';
import { SignatureStatus } from '../../constants/signature-status';
import type { IdpDataAlbertaCa } from '@govalta-emu/keycloak-auth-service';
import { IsEnum } from 'class-validator';
import { TrackAttempts } from '../track-attempts.entity';
export class DvSignature {
  @Expose()
  id?: string;

  @Expose()
  applicationId: string;

  @Expose()
  applicantAuthorizedUser?: string; //keycloak (logged in) userid of the applicant

  @Expose()
  signerAuthorizedUser?: string; //keycloak (logged in) userid. after user enters accessCode, store their ID and authorize resolver end points with this

  @Expose()
  signerType?: string; //ex spousePartner, financialAdministrator (see signer-types.ts)

  @Expose()
  applicationData?: Record<string, string>; //used to store any information that we need from the application so that we do not have to make a db call to pull application info

  @Expose()
  signerData?: Record<string, Record<string, string>>;

  @Expose()
  email: string;

  @Expose()
  createdAt?: Date;

  @Expose()
  accessCode?: string; //accessCode (emailed to user) required to access signer page. 6 digit alpha numeric all upper case.

  @Expose()
  expiresAt?: Date; //the date where this signature request expires. 48 hour expiration from createdAt.

  @Expose()
  @IsEnum(SignatureStatus) //ensures that status is always set to one on the list
  status: string = SignatureStatus.Inactive; //see signature-status.ts

  @Expose()
  rejectReason?: string; //open text field if consent/declaration was rejected by signer

  @Expose()
  completedAt?: Date; //timestamp for verified or rejected

  @Expose()
  signerProfile?: IdpDataAlbertaCa; //snapshot the authenticated signer's profile

  @Expose()
  applicantProfile?: IdpDataAlbertaCa; //snapshot the authenticated applicant's profile

  @Expose()
  dataSnapshot?: DvSnapshot; //contains snapshot of data when signature invitation was sent

  @Expose()
  isLocked?: boolean;

  @Expose()
  lastUpdated?: Date; //track the last time this request has been updated.

  @Expose()
  lastViewed?: Date;

  @Expose()
  submittedOn?: Date; //timestamp when application was submitted

  @Expose()
  outputPdfUrl?: string;

  @Expose()
  outputPdfFileName?: string;

  @Expose()
  lastSent?: Date; //track the last time sent/resent

  @Expose()
  trackAttempts?: TrackAttempts; //snapshot the authenticated signer's profile
}
